<div class="layout-sidebar">
	<div class="content">
		<div class="layout-auto-1">
			<div class="stack-center">
				<div class="placeholder-input-element"></div>
			</div>
			<div>
				<ng-container *ngFor="let item of sidemenu">
					<button *ngIf="item.type === 1"
					        [disabled]="item.disabled"
					        class="md-menu-item" (click)="onSidemenueClick(item.component)">
						<i class="{{item.icon}}"></i>{{item.caption}}
					</button>
					<div *ngIf="item.type === 0" class="md-menu-break">{{item.caption}}</div>
				</ng-container>
			</div>
		</div>
	</div>
	<div class="content app-border-left">
		<exg-widget #widget
		            [name]="currentWidget"
		            [data]="data">
		</exg-widget>
	</div>
</div>
